<template>
    <section v-if="content" class="bg-primary content">
        <div
            class="md:container mx-auto px-4 lg:px-12 py-4 md:py-4 text-center"
        >
            <rich-text v-if="content" :text="content" :bg-dark="true" />
        </div>
    </section>
</template>

<script lang="ts" setup>
defineProps({
    content: {
        type: String,
        default: '',
    },
});
</script>

<style lang="scss" scoped>
.content {
    margin-top: 80px;
    @media (max-width: 767px),
        (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) {
        margin-top: 56px;
    }
    .rich-text {
        :deep() {
            p,
            div,
            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                margin-bottom: 1rem !important;
            }
            p {
                font-weight: 200;
                &:last-child {
                    margin-bottom: 0 !important;
                }
            }
        }
    }
}
</style>
